export default {"src":"/_next/static/media/lg_logo.4f973e97.svg","height":42,"width":108,"blurWidth":0,"blurHeight":0};